<mat-toolbar class="toolbar">
  <a
    routerLink="/"
    class="toolbar__link">
    @if (user()?.isWhiteLabel && user()?.logoUrl) {
      <img
        [src]="user()?.logoUrl"
        [alt]="'GLOBAL.COMPANY_NAME' | translate"
        class="toolbar__logo" />
    } @else {
      <vdo-icon
        svgIcon="vdo-logo"
        [width]="138"
        [height]="59" />
    }
  </a>
  <div class="toolbar__wrapper">
    <button
      vdo-btn-icon
      [matMenuTriggerFor]="langMenu">
      <vdo-icon [svgIcon]="langGetCurrentIcon()" />
    </button>
    <mat-menu #langMenu="matMenu">
      <button
        mat-menu-item
        (click)="langChange('pt-br')">
        <div class="lang-item">
          <vdo-icon svgIcon="vdo-lang-pt-br" />
          <span>Português</span>
        </div>
      </button>
      <button
        mat-menu-item
        (click)="langChange('es')">
        <div class="lang-item">
          <vdo-icon svgIcon="vdo-lang-es" />
          Español
        </div>
      </button>
      <button
        mat-menu-item
        (click)="langChange('en')">
        <div class="lang-item">
          <vdo-icon svgIcon="vdo-lang-gb" />
          English
        </div>
      </button>
    </mat-menu>

    @if (authStorageService.isAuthenticated$ | async) {
      <button
        vdo-btn
        [matMenuTriggerFor]="userMenu">
        <span>{{ user()?.name }}</span>
        <vdo-icon svgIcon="person" />
      </button>

      <mat-menu #userMenu="matMenu" xPosition="after" yPosition="below" [overlapTrigger]="false" class="user-profile-menu">
        <button mat-menu-item
        (click)="onProfileClicked()"
        >
          {{ 'NAVBAR.PROFILE' | translate }}
        </button>
        <button
          mat-menu-item
          (click)="onLogoutClicked()">
          {{ 'NAVBAR.LOGOUT' | translate }}
        </button>
      </mat-menu>
    }
  </div>
</mat-toolbar>

<!-- Logout Loading Overlay -->
@if (isLoggingOut) {
  <div class="logout-loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
